import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dataset.finetune');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dataset-finetune',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dataset.finetune/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageDatasetFinetuneComponent implements OnInit {
    public list: any[] = [];
    public loading: boolean = true;
    public search: string = '';
    public viewMode: string = 'card';
    public showCreateModal: boolean = false;
    public newTitle: string = '';
    public showDeleteModal: boolean = false;
    public deleteTarget: any = null;

    // Collection selection
    public collections: any[] = [];
    public collectionsLoading: boolean = false;
    public selectedCollectionId: string = '';

    // Review detail toggle
    public expandedIds: Set<string> = new Set();

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    public async load() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call('list', { text: this.search });
        if (code === 200) {
            this.list = data.list || [];
        }
        this.loading = false;
        await this.service.render();
    }

    public async openCreateModal() {
        this.showCreateModal = true;
        this.collectionsLoading = true;
        await this.service.render();

        const { code, data } = await wiz.call('collections');
        if (code === 200) {
            this.collections = (data.list || []).filter((c: any) => c.status === 'active');
        }
        this.collectionsLoading = false;
        await this.service.render();
    }

    public async closeCreateModal() {
        this.showCreateModal = false;
        this.newTitle = '';
        this.selectedCollectionId = '';
        await this.service.render();
    }

    public async selectCollection(id: string) {
        this.selectedCollectionId = id;
        await this.service.render();
    }

    public async create() {
        if (!this.newTitle.trim() || !this.selectedCollectionId) return;
        const { code } = await wiz.call('create', {
            title: this.newTitle,
            collection_id: this.selectedCollectionId
        });
        if (code === 200) {
            this.showCreateModal = false;
            this.newTitle = '';
            this.selectedCollectionId = '';
            await this.load();
        }
        await this.service.render();
    }

    public async confirmDelete() {
        if (!this.deleteTarget) return;
        const { code } = await wiz.call('delete', { id: this.deleteTarget.id });
        if (code === 200) {
            this.showDeleteModal = false;
            this.deleteTarget = null;
            await this.load();
        }
        await this.service.render();
    }

    public async openDelete(item: any) {
        this.deleteTarget = item;
        this.showDeleteModal = true;
        await this.service.render();
    }

    public async closeDeleteModal() {
        this.showDeleteModal = false;
        this.deleteTarget = null;
        await this.service.render();
    }

    public async setViewMode(mode: string) {
        this.viewMode = mode;
        await this.service.render();
    }

    // ── Finalize / Reopen ──

    public isReviewComplete(item: any): boolean {
        const total = item.total_count || 0;
        if (total === 0) return false;
        const reviewed = (item.approved_count || 0) + (item.rejected_count || 0) + (item.skipped_count || 0);
        return reviewed >= total;
    }

    public async finalize(item: any) {
        if (!this.isReviewComplete(item)) return;
        const res = await this.service.alert.show({
            title: '데이터셋 마감',
            message: `"${item.title}" 데이터셋을 마감하시겠습니까?\n마감하면 QA 생성, 할당, 업로드, 삭제가 비활성화됩니다.`,
            action: '마감',
            actionBtn: 'bg-emerald-500 hover:bg-emerald-600',
            cancel: '취소'
        });
        if (!res) return;
        const { code } = await wiz.call('finalize', { dataset_id: item.id });
        if (code === 200) {
            await this.load();
        }
    }

    public async reopen(item: any) {
        const res = await this.service.alert.show({
            title: '마감 해제',
            message: `"${item.title}" 데이터셋의 마감을 해제하시겠습니까?`,
            action: '해제',
            cancel: '취소'
        });
        if (!res) return;
        const { code } = await wiz.call('reopen', { dataset_id: item.id });
        if (code === 200) {
            await this.load();
        }
    }

    // ── Review Detail Toggle ──

    public async toggleDetails(item: any, event: Event) {
        event.stopPropagation();
        if (this.expandedIds.has(item.id)) {
            this.expandedIds.delete(item.id);
        } else {
            this.expandedIds.add(item.id);
        }
        await this.service.render();
    }

    public isExpanded(item: any): boolean {
        return this.expandedIds.has(item.id);
    }

    public reviewProgress(item: any): number {
        const total = item.total_count || 0;
        if (total === 0) return 0;
        const reviewed = (item.approved_count || 0) + (item.rejected_count || 0) + (item.skipped_count || 0);
        return Math.round((reviewed / total) * 100);
    }

    public pendingCount(item: any): number {
        const total = item.total_count || 0;
        const reviewed = (item.approved_count || 0) + (item.rejected_count || 0) + (item.skipped_count || 0);
        return Math.max(0, total - reviewed);
    }

    // ── Status Helpers ──

    public statusLabel(status: string): string {
        const map: any = { draft: '초안', generating: '생성 중', review: '검수 중', completed: '마감' };
        return map[status] || status;
    }

    public statusColor(status: string): string {
        const map: any = {
            draft: 'bg-zinc-100 text-zinc-600',
            generating: 'bg-amber-50 text-amber-600',
            review: 'bg-violet-50 text-violet-600',
            completed: 'bg-emerald-50 text-emerald-600'
        };
        return map[status] || 'bg-zinc-100 text-zinc-600';
    }

    public navigateTo(path: string) {
        this.service.href(path);
    }
}

export default PageDatasetFinetuneComponent;